document.addEventListener( 'DOMContentLoaded', function() {
    var splide = new Splide( '.splide',{
        pagination: false, 
        type   : 'loop',
        gap: 0,
        perPage: 1,
        perMove: 1,
        classes: {
            arrows: 'splide__arrows i-article-arrows',
            arrow : 'splide__arrow i-article-arrow',
            prev  : 'splide__arrow--prev i-article-prev',
            next  : 'splide__arrow--next i-article-next',
        }
    } );
    splide.mount();
} );